export const driversForVet = [
	{value: "FRIENDLINESS", label: "Friendliness"},
	{value: "RESPECTFUL", label: "Respectfulness"},
	{value: "PLATFORM", label: "Platform"},
	{value: "LOGISTIC", label: "Logistics"},
];

export const driversForOwner = [
	{value: "VET", label: "Vet"},
	{value: "PLATFORM", label: "Platform"},
	{value: "OUTCOME", label: "Outcome"},
	{value: "LOGISTICS", label: "Logistics"},
];

export const reasonsForRatingOwner = [
	"Price",
	"Convenience",
	"My pet become anxious at the vet",
	"Second Opinion",
	"Other"
];